import { html } from 'lit'

export const emailHeaderTemplate = html`
  <style>
    .email-header-root {
      margin: 0 auto;
      padding: 0;
      width: 100%;
      background: #00465e;
      text-align: center;
    }

    .email-header-inner {
      max-width: 640px;
      padding: 24px 0px 32px;
      text-align: left;
    }

    .email-header-logo {
      display: block;
      width: 128px;
      max-width: 100%;
      height: auto;
    }
  </style>
  <div class="email-header-root">
    <div
      data-type="slot"
      data-key="xacsrgh4dl"
      data-label="MAIN NAV - Primary logo"
    ></div>
    <div class="email-header-inner">
      <lh-container
        theme="primary-extra-dark"
        gutters="xl"
        spacing="none"
        content-width="fluid"
      >
        <a href="https://www.bluecrossnc.com">
          <img
            class="email-header-logo"
            alt="Blue Cross NC"
            data-assetid="436326"
            src="https://image.mail-bcbsnc.com/lib/fe6115707c63057e741c/m/1/88633c02-6050-460e-bda7-9fae22c5f55e.png"
            width="128"
          />
        </a>
      </lh-container>
    </div>
  </div>
`

export const emailFooterTemplate = (_isMobile: boolean) => html`
  <style>
    .email-footer-root {
      margin: 0 auto;
      width: 100%;
      background: #00465e;
    }

    .email-footer-slot {
      background: #00465e;
    }

    .email-footer-inner {
      margin: 0;
      width: 100%;
    }

    .email-footer-logo-wrap {
      text-align: left;
      padding-top: 32px;
      padding-bottom: 16px;
    }

    .email-footer-copy {
      padding-top: 0;
      padding-bottom: 48px;
      font-family: 'BlueRidgeSans', Aptos, Helvetica, Arial, sans-serif;
      font-size: 14px;
      line-height: 22px;
      font-weight: 350;
      color: #ffffff;
      text-align: left;
    }

    .email-footer-logo {
      display: block;
      width: 208px;
      max-width: 100%;
      height: auto;
    }

    .email-footer-text {
      margin: 0;
      color: #ffffff;
    }

    .email-footer-text-spaced {
      margin: 24px 0 0 0;
      color: #ffffff;
    }

    .email-footer-link {
      font-family: 'BlueRidgeSans', Aptos, Helvetica, Arial, sans-serif;
      font-size: 14px;
      line-height: 20px;
      font-weight: 350;
      color: #ffffff;
      text-decoration: underline;
    }
  </style>
  <div class="email-footer-root">
    <div
      class="email-footer-slot"
      data-type="slot"
      data-key="17y69lv24pxj"
      data-label="Footer content goes here"
    >
      <lh-container
        gutters=${_isMobile ? 'md' : 'xl'}
        theme="primary-extra-dark"
        spacing="none"
      >
        <div class="email-footer-inner">
          <div class="email-footer-logo-wrap">
            <a href="https://www.bluecrossnc.com">
              <img
                class="email-footer-logo"
                alt="Blue Cross NC"
                data-assetid="853167"
                src="https://image.mail-bcbsnc.com/lib/fe6115707c63057e741c/m/1/0cc391ce-b338-41d0-844a-9d7cc6fc95c7.png"
                width="208"
              />
            </a>
          </div>
          <div class="email-footer-copy">
            <p class="email-footer-text">
              Do not reply to this email. This is an automated system message.
            </p>
            <p class="email-footer-text-spaced">
              This email includes important information about your health plan.
              If you mark this email as SPAM, you will stop receiving important
              information about your health plan.
            </p>
            <p class="email-footer-text-spaced">
              This email was sent by:
              <br />
              Blue Cross and Blue Shield of North Carolina
              <br />
              4615 University Drive, Durham, NC 27707, United States
            </p>
            <p class="email-footer-text-spaced">
              <a
                class="email-footer-link"
                href="https://www.bcbsnc.com/policies-best-practices/privacy-policy"
                target="_blank"
              >
                Privacy Policy
              </a>
            </p>
          </div>
        </div>
      </lh-container>
    </div>
    <lh-container
      theme="primary-dark"
      gutters="none"
      spacing="none"
      content-width="fluid"
    >
      <div
        class="email-footer-operational-slot"
        data-type="slot"
        data-key="operationalunumber"
        data-label="UnumberCPCnumber and date goes here"
        data-allowed-blocks="imageblock; textblock; freeformblock; abtestblock; dynamicblock"
      ></div>
    </lh-container>
  </div>
`
